export const translationKeys = {
  ariaLabel: 'hamburgerOverlay_ariaLabel',
};

export const dataHooks = {
  dialog: 'hamburger-overlay-dialog',
  root: 'hamburger-overlay-root',
};
